import T from 'prop-types';
import React from 'react';
import reactHtmlParser from 'react-html-parser';
import styled from 'styled-components';
import styles from './textBlock.css';

const Text = styled.span`
  margin-top: 0;
  color: ${({ color }) => color};
`;

const Title = Text.withComponent('h2');
const Subtitle = Text.withComponent('h3');
const Description = Text.withComponent('div');

const TextBlock = ({
  title, subtitle, description, colors,
}) => (
  <React.Fragment>
    {title && (
      <Title className={styles.title} color={colors.title}>
        {reactHtmlParser(title)}
      </Title>
    )}
    {subtitle && (
      <Subtitle className={styles.subtitle} color={colors.subtitle}>
        {reactHtmlParser(subtitle)}
      </Subtitle>
    )}
    {description && (
      <Description className={styles.description} color={colors.description}>
        {reactHtmlParser(description)}
      </Description>
    )}
  </React.Fragment>
);

TextBlock.defaultProps = {
  title: '',
  subtitle: '',
  description: '',
  colors: {
    title: '',
    subtitle: '',
    description: '',
  },
};
TextBlock.propTypes = {
  title: T.string,
  subtitle: T.string,
  description: T.oneOfType([T.string, T.arrayOf(T.string)]),
  colors: T.shape({
    title: T.string,
    subtitle: T.string,
    description: T.string,
  }),
};

export default TextBlock;



// WEBPACK FOOTER //
// ./src/components/modules/TextBlock1/TextBlock.js